module.exports = __webpack_public_path__ + "img/1521746579.ff4acf90.jpg";